/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');

var PlaceholderView = require('common/views/PlaceholderView');

var GetAllInvInqLookups = require('../../common/services/GetAllInvInqLookups');
var GetInvestigationInquiryRelatedCaseByInvInq = require('../services/GetInvestigationInquiryRelatedCaseByInvInq');
var SecInvInqSectionRelatedCaseView = require('../views/SecInvInqSectionRelatedCaseView');

module.exports = {
  channel: 'sc',

  event: 'build:inv-inq-section-related-case-view',

  builder: function(invInqId) {
    return new PlaceholderView({
      viewPromise: buildRelatedCaseView(invInqId)
    });
  }
};

function buildRelatedCaseView(invInqId) {
  var deferred = $.Deferred();
  $.when(GetInvestigationInquiryRelatedCaseByInvInq(invInqId), GetAllInvInqLookups())
    .done(function(cases, lookups) {
      deferred.resolve(
        new SecInvInqSectionRelatedCaseView({
          model: new Backbone.Model({
            invInqId: invInqId,
            relatedCases: cases.relatedCases,
            otherSubjects: cases.otherSubjects,
            invInqRelatedCaseTypes: lookups.invInqRelatedCaseTypes
          })
        })
      );
    })
    .fail(function(err) {
      deferred.reject(err);
    });

  return deferred.promise();
}
